/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { copyToClipboard } from '@app/app/shared/helpers/copy-clipboard.helper';

@Component({
  templateUrl: './share-dialog.component.html',
  styleUrls: ['./share-dialog.component.scss'],
})
export class ShareDialogComponent implements OnInit {
  shareLink: string;

  constructor(private dialogRef: MatDialogRef<ShareDialogComponent>) {}

  ngOnInit() {
    this.shareLink = window.location.href;
  }

  onCopy() {
    copyToClipboard(this.shareLink);
  }
}
